import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { dateFormat } from 'utils';
import { Notice } from './ui';

export default function RejectEdit({ time, message, projectId, removeEdit }) {
  return (
    <Notice
      tone="warnung"
      title="Deine Änderungen wurden nicht übernommen"
      onClose={() => removeEdit(projectId)}
    >
      Dein Projekt bleibt so online, wie es vorher war. Eingereicht am{' '}
      {moment.unix(time).format(dateFormat)}.
      {message && <> Grund: {message}</>} Fragen beantwortet dir unser{' '}
      <Link to="/contact-us">Support</Link>.
    </Notice>
  );
}

RejectEdit.propTypes = {
  time: PropTypes.number.isRequired,
  message: PropTypes.string,
  projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  removeEdit: PropTypes.func.isRequired,
};
